import React from 'react';
import { classNames } from '~/utils/classNames';
import { FrameworkIcons } from '~/lib/ui/icons';

interface PresetCardProps {
  id: string;
  icons: string[];
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
}

export default function PresetCard({ id, icons, title, description, isSelected, onClick }: PresetCardProps) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        'flex flex-col items-start gap-3 p-4 rounded-lg border transition-all text-left hover:scale-[1.02]',
        isSelected
          ? 'bg-dualite-background-button border-dualite-border-secondary border-2'
          : 'border-dualite-border-primary hover:border-dualite-border-secondary',
      )}
    >
      <div className="flex gap-2">
        {icons.map((iconName) => (
          <div key={iconName} className="flex-shrink-0">
            {FrameworkIcons[iconName]}
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-medium text-dualite-text-primary">{title}</h3>
        <p className="text-xs text-dualite-text-secondary leading-relaxed">{description}</p>
      </div>
    </button>
  );
}
